// Fix accessibility for plugin-generated SVGs
document.addEventListener('DOMContentLoaded', () => {
  const fixPluginSvgs = () => {
    const svgs = document.querySelectorAll('.VIpgJd-ZVi9od-aZ2wEe');
    svgs.forEach(svg => {
      if (!svg.hasAttribute('aria-hidden')) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      }
    });
  };

  fixPluginSvgs();

  // Also watch for dynamically added SVGs
  const observer = new MutationObserver(fixPluginSvgs);
  observer.observe(document.body, { childList: true, subtree: true });
});